import { authGet } from '../http_client.js';
import type { LeaderboardBoardDto, LeaderboardScope } from '../dto/leaderboard.dto.js';

export function getLeaderboardBoard( scope: LeaderboardScope ): Promise<LeaderboardBoardDto>
{
  return authGet<LeaderboardBoardDto>( `api/player/me/leaderboard?scope=${scope}` );
}
